module.exports = __webpack_public_path__ + "static/img/W.c53ee2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mszj/W.png
// module id = mi4C
// module chunks = 0